// The portfolio builder (Panther Onboarding). The tool itself is its own
// project, github.com/wavebyrd/panther-tokenization-onboarding, built as a
// static widget and served from /tokenization/onboarding/app/ (see
// scripts/sync-onboarding-widget.mjs). It runs entirely in the visitor's
// browser: the plan is computed locally, catalogs and fund data come from this
// site's API, and fills are quoted by the swap aggregators. No Worker code runs.
//
// It is framed so its styles and its wider connect-src (aggregators, public RPC
// endpoints) stay on its own path; public/_headers sets both for that path only.

import { useEffect, useRef, useState } from "react";

const WIDGET = "/tokenization/onboarding/app/";

export function Onboarding() {
  const frame = useRef<HTMLIFrameElement>(null);
  const [height, setHeight] = useState(1400);

  useEffect(() => {
    const onMessage = (event: MessageEvent) => {
      if (event.origin !== location.origin || event.source !== frame.current?.contentWindow) return;
      const data = event.data as { type?: string; height?: number } | null;
      if (data?.type === "panther-onboarding:height" && typeof data.height === "number" && data.height > 200) {
        setHeight(Math.ceil(data.height));
      }
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  return (
    <main className="onboarding">
      <iframe
        ref={frame}
        src={WIDGET}
        title="Portfolio builder"
        style={{ display: "block", width: "100%", height, border: 0, background: "transparent" }}
        loading="eager"
      />
      <p className="footer" style={{ border: 0, padding: "4px 26px 20px" }}>
        Educational simulation, not advice. Source:{" "}
        <a href="https://github.com/wavebyrd/panther-tokenization-onboarding" target="_blank" rel="noreferrer">
          panther-tokenization-onboarding ↗
        </a>
      </p>
    </main>
  );
}
